// (function ($) {
//     $.fn.footnoteTooltip = function () {
//         //set footnote shape
//         $(window).on('load', function () {
//             $('body').find('.fr-definition-tooltip').each(function () {
//                 footnoteShape($(this));
//             });

//             $('body').find('.fr-custom-tooltip').each(function () {
//                 footnoteShape($(this));
//             });
//         });

//         function footnoteShape (footnote) { 
//           const tooltip_index = footnote.attr('tooltip-index');
//             var class_name = ''; 

//             if(tooltip_index <= 99) {
//                 class_name = 'circle-tooltip';
//             } else {
//                 class_name = 'oval-tooltip';
//             }

//             footnote.addClass(class_name);
//         }

//         return this;
//     }

//     $(() => {
//         $('body').footnoteTooltip();
//     })

// })($);






// WEBPACK FOOTER //
// ./scripts/modules/blocks/footnote-tooltip.js